import { render, staticRenderFns } from "./ViewLanguage.vue?vue&type=template&id=6b08e580&"
import script from "./ViewLanguage.vue?vue&type=script&lang=js&"
export * from "./ViewLanguage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports